/**
 * @generated SignedSource<<8cc1523562dd0834a44d795e8fc13b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "takeImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ImpulseEndpoint",
        "kind": "LinkedField",
        "name": "impulseEndpoints",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numbers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlantScanBaseImplTakeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlantScanBaseImplTakeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2754f1ba9908ffac3006ebd9ab9d6af0",
    "id": null,
    "metadata": {},
    "name": "PlantScanBaseImplTakeMutation",
    "operationKind": "mutation",
    "text": "mutation PlantScanBaseImplTakeMutation(\n  $request: TakeImpulseRequestInput\n) {\n  takeImpulse(request: $request) {\n    id\n    version\n    impulseEndpoints {\n      numbers\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0fb589272d22d70066040eb5639e3297";

module.exports = node;
